import type { DiscographyQueryType } from "@/types/discography";
import { ALBUM_TYPES } from "@garimpa/lib/albumTypes";
import { valueToArray } from "@garimpa/lib/valueToArray";

/** Valid `type` query values (excludes wire-only `auto`). */
const URL_DISCOGRAPHY_TYPES = ["all", ...ALBUM_TYPES] as const;

type UrlDiscographyType = (typeof URL_DISCOGRAPHY_TYPES)[number];

/**
 * Parse a single query value. Returns null if missing or not a known discography type.
 */
export function parseDiscographyTypeParam(
  value: string | null | undefined,
): UrlDiscographyType | null {
  if (value == null || value === "") return null;
  return (URL_DISCOGRAPHY_TYPES as readonly string[]).includes(value)
    ? (value as UrlDiscographyType)
    : null;
}

/**
 * Server/RSC: normalize `searchParams.type` to the RPC wire value (`auto` when absent or invalid).
 */
export function discographyQueryTypeFromSearchParams(
  type: string | string[] | undefined,
): DiscographyQueryType {
  const raw = valueToArray(type)[0];
  return parseDiscographyTypeParam(raw) ?? "auto";
}
